export default {
    talan: {
        messagePrefix: '\x15Talan Signed Message:\n',
        bech32: 'talan',
        bip32: {
            public: 0x0488b21e,
            private: 0x0488ade4
        },
        pubKeyHash: 0x42,
        scriptHash: 0x80,
        wif: 0x47
    },
    talan_testnet: {
        messagePrefix: '\x15Talan Signed Message:\n',
        bech32: 'talan',
        bip32: {
            public: 0x0488b21e,
            private: 0x0488ade4
        },
        pubKeyHash: 0x42,
        scriptHash: 0x80,
        wif: 0x47
    }
}